import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseDeleteEstablishmentCompanyMaintenanceRequiredDocumentsProps {
  establishmentCompanyId?: string;
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useDeleteEstablishmentCompanyMaintenanceRequiredDocuments = ({
  establishmentCompanyId,
  onSuccess,
  onError,
}: UseDeleteEstablishmentCompanyMaintenanceRequiredDocumentsProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['deleteEstablishmentCompanyMaintenanceRequiredDocuments'],
    mutationFn: (maintenanceRequiredDocumentId: string) => {
      const payload = {
        maintenance_required_documents_attributes: [
          {
            id: maintenanceRequiredDocumentId,
            _destroy: true,
          },
        ],
      }

      return privateAxios.put(`/establishment/companies/${establishmentCompanyId}/update_maintenance_models`, {
        company: payload,
      });
    },
    onSuccess,
    onError,
  });
}
